import React from 'react';
import dynamic from 'next/dynamic';
import { DynamicDialogLoader } from '../common';

const DialogContent = dynamic<unknown>(
  () =>
    import('./CommChannelVerificationDialogContent').then(
      (m) => m.CommChannelVerificationDialogContent
    ),
  {
    ssr: false,
    loading: DynamicDialogLoader
  }
);

export const CommChannelVerificationDialog = () => <DialogContent />;
